import Http from '@/utils/http'

export class ContactApi {
  public submitContact(params: any) {
    return Http.post('/submit_contact', params)
  }
}
